export default function getDisabledStyle() {
  if (!getDisabledStyle.style) {
    getDisabledStyle.style = {
      opacity: 0.6,
      pointerEvents: 'none',
      filter: 'saturate(0.3) brightness(0.9)',
    };
  }

  return getDisabledStyle.style;
}
